import { PartId } from '../models/parts-info.model';
import { humanizeEnumValue } from './enum-display';

/**
 * Turns a part type into a readable label, e.g. 'left_wing' -> 'Left Wing'.
 *
 * Parts whose type the backend could not map arrive as 'other'. For those the raw CBDA part
 * type is appended, e.g. 'Other (HW_TYPE_PARACHUTE)', so the actual hardware stays visible.
 */
export function formatPartType(
  partType?: string,
  rawPartType?: string,
): string {
  const displayValue = humanizeEnumValue(partType);

  return partType === PartId.PartTypeEnum.Other && rawPartType
    ? `${displayValue} (${rawPartType})`
    : displayValue;
}

/**
 * Turns a raw CBDA part sub type into a readable label, e.g.
 * 'HW_SUB_TYPE_WING_R24_VECTOR' -> 'Wing R24 Vector'.
 */
export function formatPartSubType(rawPartSubType?: string): string {
  return humanizeEnumValue(rawPartSubType);
}
